import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import React, { useState } from 'react';
import type Slider from 'react-slick';
import type { Settings } from 'react-slick';

import CardsSlider from './CardsSlider/CardsSlider';
import HeadingsSlider from './HeadingsSlider/HeadingsSlider';

export interface SharedSliderProps {
  animationSpeed: number;
  arrows: boolean;
  dots: boolean;
  focusOnSelect: boolean;
  infinite: boolean;
  onSwipe: Settings['onSwipe'];
  slideSpeed: number;
}

interface Props {
  autoRotate: boolean;
  slides: ProspectHomepageSlide[];
  slideSpeed: number;
}

const SliderLayout: React.FC<Props> = ({ autoRotate, slides, slideSpeed }) => {
  const [headingsSlider, setHeadingsSlider] = useState<Slider>();
  const [cardsSlider, setCardsSlider] = useState<Slider>();

  const sharedSliderProps: SharedSliderProps = {
    animationSpeed: 500,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    infinite: slides.length > 1,
    onSwipe: () => cardsSlider?.slickPause(),
    slideSpeed
  };

  return (
    <>
      <HeadingsSlider
        asNavFor={cardsSlider}
        sharedSliderProps={sharedSliderProps}
        slides={slides}
        sliderRef={(slider: Slider) => setHeadingsSlider(slider)}
      />
      <CardsSlider
        asNavFor={headingsSlider}
        autoRotate={autoRotate}
        sharedSliderProps={sharedSliderProps}
        slides={slides}
        sliderRef={(slider: Slider) => setCardsSlider(slider)}
      />
    </>
  );
};

export default SliderLayout;
